import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <g
          transform="translate(23, 28) scale(0.9)"
          id="Designs"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd">
          <g id="Group">
            <g id="Path-3" stroke="currentColor" strokeWidth="9.5">
              <g id="Path-2" strokeWidth="9.5">
                <path
                  d="M32.2579136,8.67889136 C32.09935,8.36127789 31.1933542,7.03842982 30.2413189,5.96555993 C29.1253545,4.70795465 27.9461308,3.6966782 27.8333219,3.59725839 C23.7728641,0.0187290473 17.844815,-0.540175471 13.3739473,0.410320654 C7.25548081,1.71109247 1.93308381,6.94174654 0.576248472,13.006176 C-1.97363822,24.4029957 4.14665204,34.4299775 14.8253797,35.8345669 C25.5041073,37.2391563 35.7739612,29.5601776 34.9539725,18.1045531"
                  id="Path"></path>
              </g>
            </g>
            <path
              d="M20.79,18 L39.79,18 L39.79,20.5132009 C39.79,22.0733587 39.6275552,22.6391096 39.3225178,23.20948 C39.0174804,23.7798504 38.5698504,24.2274804 37.99948,24.5325178 C37.4291096,24.8375552 36.8633587,25 35.3032009,25 L20.79,25 L20.79,25 L20.79,18 Z"
              id="Rectangle"
              fill="currentColor"></path>
          </g>
        </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
